import configurl from '@/config/user.env';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import { Message } from 'element-ui';
import {
    getCustomerVisitImport,
    visitTemplateDownloadApi
} from '@mdm/api/customer/customerVisitManage.js';
export const config = {
    name: 'customerVisitManage',
    searchFields: [
        {
            name: '客户编码',
            value: 'customerCode',
            type: 'input',
            isFixed: true,
            span: 3
        },
        {
            name: '客户名称',
            value: 'customerName',
            type: 'input',
            isFixed: true,
            span: 3
        },
        {
            name: '客户系',
            value: 'customerGroupName',
            type: 'advance',
            isFixed: true,
            span: 3,
            advanceConfig: [
                { prop: 'customerGroupName', value: '客户系名称' },
                { prop: 'customerGroupCode', value: '客户系编码' }
            ],
            tableConfig: [
                { prop: 'customerGroupCode', value: '客户系编码' },
                { prop: 'customerGroupName', value: '客户系名称' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: '/customer/group/info/page',
            cbParams: ['customerGroupCode', 'customerGroupName', 'topCustomerGroupCode'],
            advanceCode: 'advanceCode'
        },
        {
            name: '内外部',
            value: 'isGroupCustomer',
            optionNum: 'SYS_WM_IN_OR_OUT_CUSTOMER',
            type: 'select',
            isFixed: true,
            span: 3
        },
        {
            name: '行业',
            value: 'typeId',
            type: 'select',
            optionNum: 'SYS_SUPPLIER_INDUSTRY',
            isFixed: false,
            span: 3
        },
        {
            name: '片区',
            value: 'areaCode',
            type: 'select',
            optionNum: 'APP_COMPANY_AREA',
            isFixed: false,
            span: 3
        },
        {
            name: '分公司',
            value: 'companyName',
            type: 'advance',
            // maxNum: 10, // 多选条数限制
            isFixed: true,
            span: 3,
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称', 'displayName': 'companyNameCn' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode#companyCode', 'companyNameCn#companyName']
        },
        {
            name: '经营中心',
            value: 'businessCenterName',
            type: 'advance',
            isFixed: true,
            span: 4,
            advanceConfig: [
                { prop: 'businessCenterName', value: '经营中心名称' },
                { prop: 'businessCenterCode', value: '经营中心编码' }
            ],
            tableConfig: [
                { prop: 'businessCenterName', value: '经营中心名称', 'displayName': 'businessCenterName' },
                { prop: 'businessCenterCode', value: '经营中心编码' }
            ],
            prefix: '/api-lcs',
            advanceUrl: '/bid/queryCompanyByCodeAndName',
            cbParams: ['businessCenterCode', 'businessCenterName']
        },
        {
            name: '服务平台',
            value: 'siteName',
            type: 'advance',
            span: 4,
            rule: [
                { required: true, message: '服务平台不能为空', trigger: 'blur' }
            ],
            advanceConfig: [
                { 'prop': 'siteNameCn', 'value': '服务平台名称' },
                { 'prop': 'siteCode', 'value': '服务平台编码' }
            ],
            tableConfig: [
                { 'prop': 'siteCode', 'value': '服务平台编码' },
                { 'prop': 'siteNameCn', 'value': '服务平台名称' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popSite`,
            cbParams: ['siteCode', 'siteNameCn#siteName'],
            advanceCascade: 'companyCode#companyCode',
            isFixed: true
        },
        {
            name: '分级分类',
            value: 'visitLevel',
            type: 'select',
            optionNum: 'CUSTOMER_VISIT_LEVEL',
            isFixed: false,
            span: 3
        },
        {
            name: '拜访开始时间',
            value: 'visitTimeStart',
            type: 'time',
            time: 'daterange',
            startPlaceholder: '拜访开始时间从',
            endPlaceholder: '拜访开始时间到',
            span: 5
        },
        {
            name: '拜访闭环时间',
            value: 'visitTimeEnd',
            type: 'time',
            time: 'daterange',
            startPlaceholder: '拜访闭环时间从',
            endPlaceholder: '拜访闭环时间到',
            span: 5
        },
        {
            name: '一级问题分类',
            value: 'firstClassProblemCode',
            type: 'select',
            optionNum: 'CUSTOMER_FIRST_CLASS_PROBLEM',
            isFixed: false,
            span: 3
        },
        {
            name: '二级问题分类',
            value: 'secondClassProblemCode',
            type: 'select',
            optionNum: 'CUSTOMER_SECOND_CLASS_PROBLEM',
            isFixed: false,
            span: 3
        },
        {
            name: '拜访方式',
            value: 'visitMode',
            type: 'select',
            optionNum: 'CUSTOMER_VISIT_MODE',
            isFixed: false,
            span: 3
        },
        {
            name: '任务状态',
            value: 'statusCode',
            type: 'select',
            optionNum: 'CUSTOMER_VISIT_INFO_STATUS',
            isFixed: false,
            span: 3
        }
    ],
    selection: true,
    index: false,
    columns: [
        {
            label: '任务状态',
            prop: 'statusCode',
            type: 'select',
            optionsKey: 'CUSTOMER_VISIT_INFO_STATUS', // TODO
            width: 100
        },
        {
            label: '客户编码',
            prop: 'customerCode',
            width: 130
        },
        {
            label: '客户名称',
            prop: 'customerName',
            width: 200
        },
        {
            label: '客户系',
            prop: 'customerGroupName'
        },
        {
            label: '内外部',
            prop: 'isGroupCustomer',
            type: 'select',
            optionsKey: 'SYS_WM_IN_OR_OUT_CUSTOMER'
        },
        {
            label: '被拜访人',
            prop: 'contactCn'
        },
        {
            label: '联系方式',
            prop: 'contactMobileCn',
            width: 120
        },
        {
            label: '核心问题',
            prop: 'issues',
            width: 220

        },
        {
            label: '行业',
            prop: 'typeName',
            width: 100
        },
        {
            label: '片区',
            prop: 'areaName'
        },
        {
            label: '分公司',
            prop: 'companyName',
            width: 120
        },
        {
            label: '经营中心',
            prop: 'businessCenterName',
            width: 150
        },
        {
            label: '服务平台',
            prop: 'siteName',
            width: 130
        },
        {
            label: '分级分类',
            prop: 'visitLevel',
            type: 'select',
            optionsKey: 'CUSTOMER_VISIT_LEVEL',
            width: 90
        },
        {
            label: '拜访开始时间',
            prop: 'visitTimeStart',
            width: 120
        },
        {
            label: '拜访闭环时间',
            prop: 'visitTimeEnd',
            width: 120
        },
        {
            label: '一级问题分类',
            prop: 'firstClassProblemCode',
            type: 'select',
            optionsKey: 'CUSTOMER_FIRST_CLASS_PROBLEM',
            width: 110
        },
        {
            label: '二级问题分类',
            prop: 'secondClassProblemCode',
            type: 'select',
            optionsKey: 'CUSTOMER_SECOND_CLASS_PROBLEM',
            width: 110
        },
        {
            label: '拜访责任人',
            prop: 'ownerName',
            width: 110
        },
        {
            label: '拜访责任人MIP',
            prop: 'ownerCode',
            width: 130
        },
        {
            label: '审批人',
            prop: 'approverName',
            width: 110
        },
        {
            label: '审批人MIP',
            prop: 'approverCode',
            width: 130
        },
        {
            label: '拜访方式',
            prop: 'visitMode',
            type: 'select',
            optionsKey: 'CUSTOMER_VISIT_MODE',
            width: 110
        },
        {
            label: '拜访内容记录',
            prop: 'content',
            width: 200
        },
        {
            label: '废弃原因',
            prop: 'abandonReason',
            width: 200
        },
        {
            label: '流程流转记录',
            prop: 'fdId',
            type: 'custom',
            width: 130
        },
        {
            label: '创建人',
            prop: 'createUserCode',
            width: 114
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 154
        },
        {
            label: '修改人',
            prop: 'updateUserCode',
            width: 114
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            width: 154
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 120, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            {
                label: '编辑',
                event: 'edit',
                displayRule: (row) => {
                    if (otherUtils.getHasAuth(btnAuthority.customerVisitManage.edit) && ['draft'].includes(row.statusCode)) {
                        return true;
                    }
                }
            },
            {
                label: '查看',
                event: 'look',
                displayRule: () => {
                    return true;
                }
            }
        ]
    },
    PANELMAX: 8,
    LASTFOUR: 4,
    LASTSIX: 6,
    importConfig: {
        action: configurl.apiUrl + 'api-lcrm/contractEnclosureInfo/upload',
        downloadApi: visitTemplateDownloadApi,
        importApi: getCustomerVisitImport,
        downParams: {
            fileName: '重点客户分级管理导入模板.xlsx'
        },
        multiple: false,
        accept: '.xlsx',
        downBtn: false,
        showFileList: false,
        fileType: '只能上传Excel文件',
        manualUpload: true,
        beforeUploadFunc: (res) => {
            const file = res.file;
            const fileName = file.name;
            const ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
            const accept = config.importConfig.accept;
            const acceptList = accept.split(',').map(item => item.trim().toLowerCase());
            if (!acceptList.includes(ext)) {
                const acceptText = Array.isArray(accept) ? accept.join('、') : accept.replace(/,/g, '、');
                Message.warning(`仅支持${acceptText} 格式文件，请重新选择`);
                return false;
            }
            return true;
        }
    }
};
